import { render } from "./ButtonClose.vue?vue&type=template&id=3ca0fefd&scoped=true"
const script = {}

import "./ButtonClose.vue?vue&type=style&index=0&id=3ca0fefd&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca0fefd"]])

export default __exports__